'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.errorFormat = exports.Schema = exports.Is = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Any = require('./rules/Any');

var _Numeric = require('./rules/Numeric');

var _String = require('./rules/String');

var _Date = require('./rules/Date');

var _Schema = require('./Schema');

var _Schema2 = _interopRequireDefault(_Schema);

var _errorFormat = require('./errorFormat');

var _errorFormat2 = _interopRequireDefault(_errorFormat);

var _validate = require('./validate');

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IsFactory = function () {
  function IsFactory() {
    _classCallCheck(this, IsFactory);
  }

  _createClass(IsFactory, [{
    key: 'any',
    value: function any() {
      return new _Any.AnyRule();
    }
  }, {
    key: 'numeric',
    value: function numeric(message) {
      return new _Numeric.NumericRule({}, message);
    }
  }, {
    key: 'string',
    value: function string(message) {
      return new _String.StringRule({}, message);
    }
  }, {
    key: 'date',
    value: function date(format, message) {
      return new _Date.DateRule({}, format, message);
    }
  }]);

  return IsFactory;
}();

var Is = new IsFactory();

exports.Is = Is;
exports.Schema = _Schema2.default;
exports.errorFormat = _errorFormat2.default;
exports.validate = _validate2.default;